import PropTypes from "prop-types";
import MenuItem from "layout/Menu/MenuItem";
import { useAccount } from "context/AccountContext";

import { ReactComponent as MegaphoneIcon } from "assets/images/icons/megaphone.svg";
import { ReactComponent as GroupsIcon } from "assets/images/icons/groups.svg";
import { ReactComponent as CalenderIcon } from "assets/images/icons/calendar.svg";
import { ReactComponent as PinIcon } from "assets/images/icons/pin.svg";
import { ReactComponent as StoreIcon } from "assets/images/icons/store.svg";

function MainMenuList({ onClick }) {
  const { user } = useAccount();

  const navigation = [
    {
      title: `Doe mee`,
      link: `/doe-mee`,
      icon: <MegaphoneIcon/>,
      needsAuthentication: true,
      items: [
        {
          title: `Thema van de maand`,
          link: `/doe-mee/thema-van-de-maand`,
        },
        {
          title: `De grote vraag`,
          link: `/doe-mee/de-grote-vraag`,
        },
        {
          title: `Foto van de maand`,
          link: `/doe-mee/foto-van-de-maand`,
        },
        {
          title: `Puzzels`,
          link: `/doe-mee/spelletjes`
        },
      ]
    },
    { title: `Vraag & aanbod`, link: `/vraag-en-aanbod`, icon: <StoreIcon/>, needsAuthentication: true },
    { title: `Ledenprikbord`, link: `/prikbord`, icon: <PinIcon/>, needsAuthentication: true },
    { title: `Groepen`, link: `/groepen`, icon: <GroupsIcon/>, needsAuthentication: true },
    { title: `Activiteiten`, link: `/activiteiten`, icon: <CalenderIcon/>, needsAuthentication: true },
  ];

  return (
    <>
      {
        navigation.map(
          (item, index) => {
            const disabled = item.needsAuthentication && !user;
            const subItems = !disabled ? item.items : [];
            return (
              <MenuItem
                key={ index }
                title={ item.title }
                link={ item.link }
                icon={ item.icon }
                disabled={ disabled }
                onClick={ onClick }
                mobileOnly={ item.mobileOnly }
                subItems={ subItems }
              />
            )
          }
        )
      }
    </>
  );
}

MainMenuList.propTypes = {
  helpClass: PropTypes.string,
}

export default MainMenuList;
